import Vue from 'vue'

// Global stuff
Vue.mixin({
  methods: {
    getFixedValue (val) {
      val = parseFloat(val)
      let fixedval = val.toFixed(2)

      if (fixedval === '0.70' && val > 0.7) {
        fixedval = 0.701
      }

      if (fixedval === '0.40' && val < 0.40) {
        fixedval = 0.399
      }

      return fixedval
    },

    apiRefreshToken () {
      let date = new Date()
      let token = date.getFullYear() +
        '-' + date.getDate() +
        '-' + (date.getMonth() + 1) +
        '-' + date.getHours()

      return token
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins.js